var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content modals-start-over"
  }, [_vm.$store.state.utils.configuration.enableNewStartOverModal ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v("\n        " + _vm._s(_vm.translations.startOverDescription1) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.translations.startOverDescription2) + "\n      ")])]), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageUrl && !_vm.showSpinner,
      expression: "imageUrl && !showSpinner"
    }],
    staticClass: "modals-start-over-img",
    attrs: {
      "src": _vm.imageUrl,
      "alt": _vm.pdm.product_name
    },
    on: {
      "load": function load($event) {
        return _vm.hideSpinner(true);
      }
    }
  })]), _c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }]
  })], 1) : _c('div', [_c('h5', {
    staticClass: "text-center subheader"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.startOverSubHeader1) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.translations.startOverSubHeader2) + "\n    ")]), _c('div', {
    staticClass: "modal-img-wrapper modals-start-over-wrapper"
  }, [_c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }]
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageUrl && !_vm.showSpinner,
      expression: "imageUrl && !showSpinner"
    }],
    staticClass: "modals-start-over-wrapper-img",
    attrs: {
      "src": _vm.imageUrl,
      "alt": _vm.pdm.product_name
    },
    on: {
      "load": function load($event) {
        return _vm.hideSpinner(true);
      }
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }